(function () {
  document.querySelectorAll('.svc').forEach(function (root) {
    var track = root.querySelector('[data-svc-track]');
    var prev = root.querySelector('[data-svc-prev]');
    var next = root.querySelector('[data-svc-next]');
    if (!track) return;

    // --- Arrow scrolling ---
    function slideWidth() {
      var slide = track.querySelector('.svc__slide');
      var gap = parseInt(getComputedStyle(track).gap) || 18;
      return slide ? slide.getBoundingClientRect().width + gap : 300;
    }
    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -slideWidth() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: slideWidth() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // --- Autoplay videos only while visible ---
    var videos = root.querySelectorAll('[data-svc-video]');
    if ('IntersectionObserver' in window && videos.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.6 });
      videos.forEach(function (v) {
        io.observe(v);
        // reveal mute button once we know it's a real video
        var btn = v.closest('.svc__media').querySelector('[data-svc-mute]');
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            v.muted = !v.muted;
            btn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
            btn.classList.toggle('is-on', !v.muted);
          });
        }
      });
    }

    // --- Only one product card open at a time ---
    var cards = root.querySelectorAll('[data-svc-card]');
    cards.forEach(function (card) {
      card.addEventListener('toggle', function () {
        if (card.open) cards.forEach(function (c) { if (c !== card) c.open = false; });
      });
    });

    // --- Ajax add to cart ---
    root.querySelectorAll('[data-svc-form]').forEach(function (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = form.querySelector('.svc__add');
        var original = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            btn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('svc:added'));
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          })
          .catch(function () {
            btn.textContent = 'Try again';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          });
      });
    });
  });
})();
